/***
 * @Author: hippo
 * @Date: 2025-02-20 14:53:54
 * @LastEditors: hippo
 * @LastEditTime: 2025-02-25 18:27:33
 * @Description: 
 * @
 */
/**
 * 状态码: status
 */

export const orderStatus = {
  WAIT_RECIEW: 1000, // * 1000 【待接收】创建工单已创建，客服待确认接收
  WAIT_PRICING: 2001, // * 2001 【待定价】客服正在跟进，客服已确认，待定价的环节
  WAIT_LOCK_FEE: 2002, // * 2002 【待定价|待锁定】已定价，待锁定/冻结
  LOCK_FEE_FAILD: 2003, // * 2003 【记账失败】账户锁定/冻结失败 
  CHANGE_FEE: 2004, // * 2003 调整价格 
  WAIT_ASSIGN: 3001, // * 3001 【待指派】锁定成功，待指派师傅
  PROCESSING_WAIT_APPOINTMENT: 4001, // * 4001 【进行中】已指派，待预约时间
  PROCESSING_WAIT_SERVICE: 4002, // * 4002 【进行中|待上门】已约时间，待上门
  WORKER_LOCATION_CHECKED: 4003, // * 4003 【进行中|已上门】师傅签到
  ORDER_INSPECTION: 4004, // * 4004 安装单 验货
  // PROCESSING_FAILD_SERVICE: 4004, // * 4003 【上门失败】上门失败
  // PROCESSING_WAIT_EXPRESS: 4005, // * 4004 【等待返件】等待返件
  PROCESSING_COMPLETED: 4006, // * 4005 【上门完成|待确认】完成上门，待客服确认
  PROCESSING_WAIT_TENANT_RECEIPT: 5001, // * 5001 【待确认】待企业确认
  DONE: 6001, // * 6001 【工单完成】工单完成, 待结算(考虑去掉这个，一个DONE_CLOSE应该够了)
  DONE_CLOSE: 6002, // * 6002 【工单关闭】工单关闭，已异步结算完成
  CANCEL: 6003, // * 6003 【工单已取消】 取消工单

  TENANT_APPEAL: 6004, // * 6004 【商家申诉调价】
  MANAGER_APPEAL_FOR_WORKER: 6005, // * 6005 【客服申诉给师傅调价】
  MANAGER_APPEAL_FOR_TENANT: 6006, // 6006 【客服申诉给商家调价】

  TENANT_APPEAL_SUCCEED: 6007, // 【商家申诉成功】
  TENANT_APPEAL_FIALED: 6008, // 【商家申诉失败】
  MANAGER_APPEAL_FOR_WORKER_SUCCEED: 6009, //  【客服申诉给师傅调价成功】
  TMANAGER_APPEAL_FOR_WORKER_FIALED: 6010, // 【客服申诉给师傅调价失败】
  MANAGER_APPEAL_FOR_TENANT_SUCCEED: 6011, // 【客服申诉给商家调价成功】
  MANAGER_APPEAL_FOR_TENANT_FIALED: 6012, // 【客服申诉给商家调价失败】

  TENANT_CLOSE: 6013, // 【商家申诉取消订单】
  TENANT_CLOSE_FIALED: 6014, // 【客服拒绝取消订单】

  GUAQI: 8000,//【挂起工单】
  WORKER_GUAQI: 8001,//【师傅挂起工单】
  MANAGER_IGNORE: 8002, //【忽略工单】
  MANAGER_CLOSE: 8003, //【结束会话】
  TENANT_EVALUATE: 8004, //【商家评价】
  TENANT_CLAIM: 8005, //【商家索赔】
  MANAGER_CLAIM: 8006, //【客服审批索赔】
  EVALUATE_APPEAL: 8007,//【师傅评价申诉】
  REMIND_ORDER: 8008,//【商家催单】
  TENANT_CONFIRM_FEE: 8009,//【商家同意报价】
  TENANT_REFUSE_FEE: 8010,//【商家拒绝报价】
  WORKER_QUOTATION: 8011,//【师傅报价】
  ORDER_WAIT_QUOTATION: 9000,//【工单待报价】
  ORDER_WAIT_PAYID: 9001,//【工单待支付】
  ORDER_WAIT_EVALUATE: 9002,//【工单待评价】

  MANAGER_CLAIM_AGREE: 80012, //【客服同意索赔】
  MANAGER_CLAIM_REFRUSE: 80013, //【客服拒绝索赔】
  CODE_PROCESSING_COMPLETED: 80014,//验证码交单
  NO_CODE_PROCESSING_COMPLETED: 80015,//无验证码交单
  REMIND_QUOTATION: 80016,//用户催报价
  MODIFY_ORDER: 80117,//修改工单
  ACCEPT_FAILED_FREE_ON_SITE: 80118,//验收不通过-免费上门
  CHECK_ACCEPT_FAILED_ON_SITE: 80119,//审批散户免费上门申请
  DOWN_APPLY_FEE: 80120,//散户申请下调费用
  CHECK_DOWN_APPLY_FEE_AGREE: 80121,//同意散户申请下调费用
  WORKER_APPLY_FEE: 80122,//师傅申请新增费用
  CHECK_WORKER_APPLY_FEE_AGREE: 80123,//同意并支付师傅申请费用
  WORKER_APPLY_ARBITRATION: 80124,//师傅申请仲裁
  RETAIL_APPLY_ARBITRATION: 80125,//散户申请仲裁
  RETAIL_APPLY_ARBITRATION_APPEAL: 80126,//散户申请仲裁申诉
  WORKER_APPLY_ARBITRATION_APPEAL: 80127,//师傅申请仲裁申诉
  MANAGER_ARBITRATION_APPEAL_AGREE: 80128,//客服同意仲裁
  MANAGER_ARBITRATION_APPEAL_REFRUSE: 80129,//客服拒绝仲裁
  WORKER_ORDERINSPECT_NORMAL: 80130,//师傅验货正常
  WORKER_ORDERINSPECT_ABNORMAL: 80131,//师傅验货异常
  RETAIL_CHOICE_WORKER_PAY: 80132,//用户指派师傅并付款
  RETAIL_UP_APPLY_FEE: 80133,//散户申请新增费用并支付
  RETAIL_APPLY_BACK: 80134,//散户申请退款
  WORKER_APPLY_BACK_AGREE: 80135,//师傅同意退款
  WORKER_APPLY_BACK_REFUSE: 80136,//师傅拒绝退款
  WORKER_SIGN_CAPTCHA: 80137,//师傅输入验证码完单
  RETAIL_APPLY_WARRANTY: 80138,//散户申请质保
  WORKER_WARRANTY_AGREE: 80139,//师傅同意并预约时间
  CHECK_DOWN_APPLY_FEE_REFUSE: 80140,//拒绝散户申请下调费用
  CHECK_WORKER_APPLY_FEE_REFUSE: 80141,//拒绝师傅申请费用
  RETAIL_CONFIRM_PAY: 80142,//用户支付并验收
  RETAIL_REFUSE_WARRANTY: 80143,//用户拒绝质保
  RETAIL_CONFIRM_ORDER: 80144,//用户确认验收
  RETAIL_AUTO_CONFIRM_ORDER: 80145,//自动确认验收
  MANAGER_CONFIRM_ORDER: 80146,//客服确认验收
  TENANT_CONFIRM_ORDER: 80147,//商家确认验收
  WORKER_ARBITRATIONAGAIN:80148,//师傅补充仲裁材料
  RETAIL_ARBITRATIONAGAIN:80149,//散户补充仲裁材料
}